(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_lp-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('lp-countdown')) return;

    var formatters = {};

    // Milliseconds the given zone is ahead of UTC at instant t.
    function zoneOffset(t, timeZone) {
      var dtf = formatters[timeZone];
      if (!dtf) {
        dtf = formatters[timeZone] = new Intl.DateTimeFormat('en-US', {
          timeZone: timeZone,
          hourCycle: 'h23',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });
      }
      var parts = {};
      dtf.formatToParts(new Date(t)).forEach(function (p) {
        parts[p.type] = p.value;
      });
      var asUtc = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour % 24, +parts.minute, +parts.second);
      return asUtc - Math.floor(t / 1000) * 1000;
    }

    // "2026-11-30 23:59" read as wall-clock time in the given zone → epoch ms (NaN when unreadable).
    function parseEnd(value, timeZone) {
      var m = /^(\d{4})-(\d{1,2})-(\d{1,2})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?$/.exec((value || '').trim());
      if (!m) return NaN;
      var wall = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
      try {
        var first = zoneOffset(wall, timeZone);
        var t = wall - first;
        var second = zoneOffset(t, timeZone);
        // Re-check once: the offset can differ on the far side of a DST switch.
        return second === first ? t : wall - second;
      } catch (e) {
        return NaN;
      }
    }

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    var instances = new Set();
    var timer = null;

    function tick() {
      var now = Date.now();
      instances.forEach(function (el) {
        el.render(now);
      });
    }

    function start() {
      if (timer) return;
      tick();
      // Align to the next whole second so every countdown on the page flips together.
      timer = setTimeout(function loop() {
        tick();
        timer = setTimeout(loop, 1000 - (Date.now() % 1000));
      }, 1000 - (Date.now() % 1000));
    }

    function stop() {
      if (timer) clearTimeout(timer);
      timer = null;
    }

    class LpCountdown extends HTMLElement {
      connectedCallback() {
        this.units = {};
        var nodes = this.querySelectorAll('[data-unit]');
        for (var i = 0; i < nodes.length; i++) this.units[nodes[i].getAttribute('data-unit')] = nodes[i];
        this.live = this.querySelector('.lp-countdown__live');
        this.fallback = this.querySelector('.lp-countdown__fallback');
        this.hint = this.querySelector('.lp-countdown__hint');
        this.endTime = null;
        instances.add(this);
        start();
      }

      disconnectedCallback() {
        instances.delete(this);
        if (!instances.size) stop();
      }

      resolveEnd() {
        var zone = this.getAttribute('data-timezone') || 'Europe/Amsterdam';
        var own = (this.getAttribute('data-end') || '').trim();
        if (own) return parseEnd(own, zone);
        // No date of its own: follow the first countdown on the page that has one.
        var all = document.querySelectorAll('lp-countdown[data-end]');
        for (var i = 0; i < all.length; i++) {
          var value = (all[i].getAttribute('data-end') || '').trim();
          if (value) return parseEnd(value, all[i].getAttribute('data-timezone') || zone);
        }
        return NaN;
      }

      setState(state) {
        if (this.getAttribute('data-state') === state) return;
        this.setAttribute('data-state', state);
        var hasFallback = !!this.fallback && this.fallback.textContent.trim() !== '';
        var showFallback = state === 'ended' && hasFallback;
        var showHint = state === 'invalid' && !!this.hint;
        if (this.fallback) this.fallback.hidden = !showFallback;
        if (this.hint) this.hint.hidden = !showHint;
        // Ended without a fallback, or no usable date on the storefront: take the element out of
        // the layout entirely rather than leave an empty gap.
        var visible = state === 'running' || state === 'pending' || showFallback || showHint;
        this.style.display = visible ? '' : 'none';
        if (state === 'ended') {
          this.dispatchEvent(new CustomEvent('lp:countdown:end', { bubbles: true }));
        }
      }

      render(now) {
        // Resolved on every tick in the editor (dates change live), once on the storefront.
        if (this.endTime === null || this.hasAttribute('data-design-mode')) this.endTime = this.resolveEnd();
        if (isNaN(this.endTime)) {
          this.setState('invalid');
          return;
        }
        var left = Math.floor((this.endTime - now) / 1000);
        if (left <= 0) {
          this.setState('ended');
          return;
        }
        var d = Math.floor(left / 86400);
        left -= d * 86400;
        var h = Math.floor(left / 3600);
        left -= h * 3600;
        var m = Math.floor(left / 60);
        var s = left - m * 60;
        if (this.units.d) this.units.d.textContent = String(d);
        if (this.units.h) this.units.h.textContent = pad(h);
        if (this.units.m) this.units.m.textContent = pad(m);
        if (this.units.s) this.units.s.textContent = pad(s);
        this.setState('running');
      }
    }

    customElements.define('lp-countdown', LpCountdown);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lp-bundle-buybox"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('lp-bundle-buybox')) return;

    class LpBundleBuybox extends HTMLElement {
      connectedCallback() {
        // Bound once: the theme editor re-attaches the element when a section is moved.
        if (!this._bound) {
          this._bound = true;
          this.addEventListener('change', this.onChange.bind(this));
          this.addEventListener('click', this.onClick.bind(this));
        }
        this.lines = Array.prototype.slice.call(this.querySelectorAll('[data-lp-line-panel]'));
        this.tiles = Array.prototype.slice.call(this.querySelectorAll('[data-lp-line-tile]'));
        var preferred = this.getAttribute('data-default-tier') || '6';
        this.lines.forEach(function (panel) {
          if (!panel.querySelector('input[data-lp-tier]:checked')) {
            var inputs = panel.querySelectorAll('input[data-lp-tier]');
            var pick = panel.querySelector('input[data-lp-tier][value="' + preferred + '"]') || inputs[0];
            if (pick) pick.checked = true;
          }
        });
        this.selectLine(0, { keepTier: false, scroll: false, silent: true });
        // Publish after the rest of the page (sticky bar) has had a chance to connect.
        var self = this;
        requestAnimationFrame(function () {
          self.publish();
        });
        LpBundleBuybox.instances.add(this);
      }

      disconnectedCallback() {
        LpBundleBuybox.instances.delete(this);
      }

      get activePanel() {
        return this.lines[this.activeIndex || 0];
      }

      onChange(event) {
        var input = event.target;
        if (input.matches && input.matches('input[data-lp-line-radio]')) {
          this.selectLine(this.tiles.indexOf(input.closest('[data-lp-line-tile]')), { keepTier: true });
          return;
        }
        if (!input.matches || !input.matches('input[data-lp-tier]')) return;
        this.updatePanel(input.closest('[data-lp-line-panel]'));
        this.publish();
      }

      onClick(event) {
        var thumb = event.target.closest('[data-lp-thumb]');
        if (thumb && this.contains(thumb)) {
          this.showImage(thumb.closest('[data-lp-line-panel]'), thumb);
        }
      }

      selectLine(index, options) {
        options = options || {};
        if (index < 0 || index >= this.lines.length) return;
        var previous = this.activePanel;
        var tier = null;
        if (options.keepTier && previous) {
          var checked = previous.querySelector('input[data-lp-tier]:checked');
          if (checked) tier = checked.value;
        }
        this.activeIndex = index;
        this.lines.forEach(function (panel, i) {
          panel.hidden = i !== index;
        });
        this.tiles.forEach(function (tile, i) {
          var radio = tile.querySelector('input[data-lp-line-radio]');
          if (radio) radio.checked = i === index;
        });
        var panel = this.lines[index];
        if (tier) {
          var same = panel.querySelector('input[data-lp-tier][value="' + tier + '"]');
          if (same) same.checked = true;
        }
        var first = panel.querySelector('[data-lp-thumb]');
        if (first) this.showImage(panel, first);
        this.updatePanel(panel);
        if (!options.silent) this.publish();
      }

      showImage(panel, thumb) {
        if (!panel || !thumb) return;
        var main = panel.querySelector('[data-lp-main-image]');
        if (main) {
          var src = thumb.getAttribute('data-src');
          if (src) {
            main.removeAttribute('srcset');
            main.setAttribute('src', src);
            var srcset = thumb.getAttribute('data-srcset');
            if (srcset) main.setAttribute('srcset', srcset);
          }
        }
        var thumbs = panel.querySelectorAll('[data-lp-thumb]');
        for (var i = 0; i < thumbs.length; i++) {
          thumbs[i].setAttribute('aria-current', thumbs[i] === thumb ? 'true' : 'false');
        }
      }

      updatePanel(panel) {
        if (!panel) return;
        var input = panel.querySelector('input[data-lp-tier]:checked');
        if (!input) return;
        var d = input.dataset;
        var set = function (selector, html, isHtml) {
          var nodes = panel.querySelectorAll(selector);
          for (var i = 0; i < nodes.length; i++) {
            if (isHtml) nodes[i].innerHTML = html;
            else nodes[i].textContent = html;
          }
        };
        set('[data-lp-out="price"]', d.price || '', true);
        set('[data-lp-out="compare"]', d.compare || '', true);
        set('[data-lp-out="summary"]', d.summary || '', false);
        set('[data-lp-out="bundle-label"]', d.label || '', false);
        var compareNodes = panel.querySelectorAll('[data-lp-out="compare"]');
        for (var c = 0; c < compareNodes.length; c++) compareNodes[c].hidden = !d.compare;
        var stock = panel.querySelector('[data-lp-out="stock"]');
        if (stock) stock.hidden = d.available !== 'true';
        var cta = panel.querySelector('[data-lp-out="cta"]');
        if (cta && d.href) cta.setAttribute('href', d.href);
        // The gallery's pack slot follows the tier; refresh the main image if it is showing.
        var slot = panel.querySelector('[data-lp-thumb][data-pack-slot]');
        if (slot && d.img) {
          slot.setAttribute('data-src', d.img);
          slot.setAttribute('data-srcset', d.imgSrcset || '');
          var slotImg = slot.querySelector('img');
          if (slotImg) {
            slotImg.removeAttribute('srcset');
            slotImg.setAttribute('src', d.thumb || d.img);
          }
          if (slot.getAttribute('aria-current') === 'true') this.showImage(panel, slot);
        }
      }

      getState() {
        var panel = this.activePanel;
        if (!panel) return null;
        var input = panel.querySelector('input[data-lp-tier]:checked');
        if (!input) return null;
        var d = input.dataset;
        return {
          line: this.activeIndex + 1,
          lineTitle: panel.getAttribute('data-line-title') || '',
          tier: input.value,
          name: d.name || '',
          title: d.title || '',
          priceHtml: d.price || '',
          compareHtml: d.compare || '',
          pairsText: d.pairs || '',
          perText: d.per || '',
          summaryText: d.summary || '',
          href: d.href || '',
          image: d.thumb || d.img || '',
          available: d.available === 'true',
        };
      }

      publish() {
        document.dispatchEvent(new CustomEvent('lp:buybox:change', { detail: { source: this, state: this.getState() } }));
      }
    }

    LpBundleBuybox.instances = new Set();
    customElements.define('lp-bundle-buybox', LpBundleBuybox);

    // Lineup cards and other links: <a href="#pick" data-lp-select-line="2">.
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-lp-select-line]');
      if (!trigger) return;
      var index = parseInt(trigger.getAttribute('data-lp-select-line'), 10) - 1;
      var hash = (trigger.getAttribute('href') || '').split('#')[1];
      var target = (hash && document.getElementById(hash)) || null;
      var box = target && target.matches('lp-bundle-buybox') ? target : document.querySelector('lp-bundle-buybox');
      if (!box || isNaN(index)) return;
      event.preventDefault();
      box.selectLine(index, { keepTier: true });
      box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Move keyboard focus along, or the next Tab jumps back up to the lineup cards.
      var focusEl = box.querySelector('input[data-lp-line-radio]:checked') || (box.activePanel && box.activePanel.querySelector('input[data-lp-tier]:checked'));
      if (focusEl) focusEl.focus({ preventScroll: true });
      if (box.id && history.replaceState) history.replaceState(null, '', '#' + box.id);
    });

    // Theme editor: selecting a line in the sidebar shows that line.
    document.addEventListener('shopify:block:select', function (event) {
      var panel = event.target && event.target.closest && event.target.closest('[data-lp-line-panel]');
      if (!panel) return;
      var box = panel.closest('lp-bundle-buybox');
      if (box) box.selectLine(box.lines.indexOf(panel), { keepTier: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lp-bundle-sticky-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('lp-bundle-sticky-bar')) return;

    // One rAF-throttled scroll listener for every bar on the page.
    var bars = new Set();
    var ticking = false;

    function update() {
      ticking = false;
      bars.forEach(function (bar) {
        bar.updateVisibility();
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    class LpBundleStickyBar extends HTMLElement {
      connectedCallback() {
        this.refs = {};
        var nodes = this.querySelectorAll('[data-lp-sticky]');
        for (var i = 0; i < nodes.length; i++) {
          var key = nodes[i].getAttribute('data-lp-sticky');
          (this.refs[key] = this.refs[key] || []).push(nodes[i]);
        }
        this.threshold = parseInt(this.getAttribute('data-show-after'), 10);
        if (isNaN(this.threshold)) this.threshold = 600;
        this.hasState = false;

        this.onState = this.onState.bind(this);
        document.addEventListener('lp:buybox:change', this.onState);
        var box = document.querySelector('lp-bundle-buybox');
        if (box && typeof box.getState === 'function') this.render(box.getState());

        if (!bars.size) window.addEventListener('scroll', onScroll, { passive: true });
        bars.add(this);

        // Hidden while the footer is on screen, so the bar never covers its policy links and the
        // language/country switcher (the footer ends with only 36px of padding).
        // The footer group is several sections; any of them on screen counts.
        this.footerInView = false;
        var footers = document.querySelectorAll('.shopify-section-group-footer-group');
        if (footers.length && 'IntersectionObserver' in window) {
          var self = this;
          var onScreen = new Set();
          this.footerObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) onScreen.add(entry.target);
              else onScreen.delete(entry.target);
            });
            self.footerInView = onScreen.size > 0;
            self.updateVisibility();
          });
          footers.forEach(function (footer) {
            self.footerObserver.observe(footer);
          });
        }
        this.updateVisibility();
      }

      disconnectedCallback() {
        document.removeEventListener('lp:buybox:change', this.onState);
        if (this.footerObserver) this.footerObserver.disconnect();
        bars.delete(this);
        if (!bars.size) window.removeEventListener('scroll', onScroll);
      }

      onState(event) {
        this.render(event.detail && event.detail.state);
      }

      set(key, value, isHtml) {
        (this.refs[key] || []).forEach(function (node) {
          if (isHtml) node.innerHTML = value;
          else node.textContent = value;
        });
      }

      render(state) {
        this.hasState = !!(state && state.href);
        if (this.hasState) {
          this.set('name', state.name);
          this.set('line', state.lineTitle);
          this.set('pairs', state.pairsText);
          this.set('price', state.priceHtml, true);
          this.set('compare', state.compareHtml, true);
          this.set('summary', state.summaryText);
          (this.refs.cta || []).forEach(function (a) {
            a.setAttribute('href', state.href);
          });
          (this.refs.image || []).forEach(function (img) {
            if (state.image) {
              img.setAttribute('src', state.image);
              img.hidden = false;
            } else {
              img.hidden = true;
            }
          });
        }
        this.updateVisibility();
      }

      updateVisibility() {
        var visible = this.hasState && !this.footerInView && window.scrollY > this.threshold;
        this.classList.toggle('lp-bsticky--visible', visible);
      }
    }

    customElements.define('lp-bundle-sticky-bar', LpBundleStickyBar);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lp-explainer"] && !Shopify.designMode) return;
  try {
    (function () {
    window.BOXR = window.BOXR || {};
    if (window.BOXR.lpExplainerBound) return;
    window.BOXR.lpExplainerBound = true;

    // The markers are built here rather than in Liquid: a child block cannot know its own index,
    // and each marker has to sit inside the image box, positioned in percent of that box.
    function clamp(value) {
      var n = parseFloat(value);
      if (isNaN(n)) return 50;
      return Math.min(100, Math.max(0, n));
    }

    function build(root, active) {
      var media = root.querySelector('[data-lp-explainer-media]');
      var template = root.querySelector('template[data-lp-explainer-marker]');
      var proto = template && template.content ? template.content.firstElementChild : null;
      if (!media || !proto) return;

      var old = media.querySelectorAll('[data-lp-explainer-live]');
      for (var i = 0; i < old.length; i++) old[i].remove();

      // Empty points (editor only) take no number in the list, so they get no marker either.
      var points = root.querySelectorAll('[data-lp-explainer-point]:not([data-empty])');
      for (var j = 0; j < points.length; j++) {
        var marker = proto.cloneNode(true);
        marker.setAttribute('data-lp-explainer-live', '');
        marker.style.left = clamp(points[j].getAttribute('data-lp-x')) + '%';
        marker.style.top = clamp(points[j].getAttribute('data-lp-y')) + '%';
        marker.textContent = String(j + 1);
        if (active && points[j] === active) marker.setAttribute('data-active', '');
        media.appendChild(marker);
      }
    }

    function init(scope) {
      var roots = (scope || document).querySelectorAll('.lp-explainer');
      for (var i = 0; i < roots.length; i++) build(roots[i], null);
    }

    function onBlock(event, selected) {
      var target = event.target;
      if (!target || !target.closest) return;
      var root = target.closest('.lp-explainer');
      if (!root) return;
      build(root, selected ? target.closest('[data-lp-explainer-point]') : null);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
    document.addEventListener('shopify:block:select', function (event) {
      onBlock(event, true);
    });
    document.addEventListener('shopify:block:deselect', function (event) {
      onBlock(event, false);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lp-signup-sticky-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.BOXR && window.BOXR.lpSignupStickyBarBound) return;
    window.BOXR = window.BOXR || {};
    window.BOXR.lpSignupStickyBarBound = true;

    // The bar list is cached and the work is rAF-throttled: scroll fires constantly on a phone,
    // so neither the DOM query nor the attribute write belongs in the handler itself.
    var bars = [];
    var ticking = false;
    // Hidden while the footer is on screen, so the bar never covers its policy links and the
    // language/country switcher (the footer ends with only 36px of padding).
    var footerInView = false;

    function collect() {
      bars = Array.prototype.slice.call(document.querySelectorAll('[data-lp-signup-sticky-bar]'));
    }

    function toggle(bar) {
      var threshold = parseInt(bar.getAttribute('data-show-after'), 10);
      if (isNaN(threshold)) threshold = 600;
      // In the theme editor a selected bar is always shown, so it can be seen and edited.
      var visible = bar.getAttribute('data-editor-selected') === 'true' || (!footerInView && window.scrollY > threshold);
      var next = visible ? 'true' : 'false';
      if (bar.getAttribute('data-visible') !== next) bar.setAttribute('data-visible', next);
    }

    function update() {
      for (var i = 0; i < bars.length; i++) toggle(bars[i]);
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    function start() {
      collect();
      // The footer group is several sections; any of them on screen counts.
      var footers = document.querySelectorAll('.shopify-section-group-footer-group');
      if (footers.length && 'IntersectionObserver' in window) {
        var onScreen = new Set();
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) onScreen.add(entry.target);
            else onScreen.delete(entry.target);
          });
          footerInView = onScreen.size > 0;
          update();
        });
        footers.forEach(function (footer) {
          observer.observe(footer);
        });
      }
      update();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    window.addEventListener('scroll', onScroll, { passive: true });

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () {
        collect();
        update();
      });

      document.addEventListener('shopify:block:select', function (event) {
        var bar = event.target && event.target.closest ? event.target.closest('[data-lp-signup-sticky-bar]') : null;
        if (!bar) return;
        bar.setAttribute('data-editor-selected', 'true');
        update();
      });

      document.addEventListener('shopify:block:deselect', function (event) {
        var bar = event.target && event.target.closest ? event.target.closest('[data-lp-signup-sticky-bar]') : null;
        if (!bar) return;
        bar.removeAttribute('data-editor-selected');
        update();
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lp-signup"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('lp-signup-form')) return;

    var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';

    // Fallback when Liquid left the locale empty: the page language if it has a region,
    // otherwise the locale of the store subdomain.
    var SUBDOMAIN_LOCALES = {
      www: 'nl-NL',
      de: 'de-DE',
      fr: 'fr-FR',
      it: 'it-IT',
      es: 'es-ES',
      dk: 'da-DK',
      se: 'en-SE',
      uk: 'en-GB',
      us: 'en-US'
    };

    // Lowercase language, uppercase region; anything that is not a plain tag is dropped,
    // so Klaviyo never receives a malformed locale.
    function cleanTag(tag) {
      var m = /^([a-z]{2,3})(?:-([a-z]{2}))?$/i.exec((tag || '').trim());
      return m ? m[1].toLowerCase() + (m[2] ? '-' + m[2].toUpperCase() : '') : '';
    }

    function visitLocale(el) {
      var locale = cleanTag(el.getAttribute('data-locale'));
      if (locale.indexOf('-') > 0) return locale;
      var lang = cleanTag(document.documentElement.lang);
      if (lang.indexOf('-') > 0) return lang;
      var sub = window.location.hostname.split('.')[0];
      return (SUBDOMAIN_LOCALES.hasOwnProperty(sub) && SUBDOMAIN_LOCALES[sub]) || locale || lang;
    }

    function visitMarket(el, locale) {
      var market = (el.getAttribute('data-market') || '').trim();
      if (!market && locale.indexOf('-') > 0) market = locale.split('-').pop();
      return market.toUpperCase();
    }

    // Send the sign-up to TrackBee as a Lead; retries while TrackBee is still loading.
    var LEAD_RETRIES = 20;

    function trackLead(source, email, attempt) {
      if (!source) return;
      var trackBee = window.TrackBee;
      if (trackBee && typeof trackBee.track_lead === 'function') {
        try {
          trackBee.track_lead({ source: source, email: email });
        } catch (e) {}
        return;
      }
      attempt = attempt || 0;
      if (attempt < LEAD_RETRIES) {
        setTimeout(function () {
          trackLead(source, email, attempt + 1);
        }, 500);
      }
    }

    // Event delegation on the element itself: it keeps working whatever order the browser
    // parses the markup and loads this script in, and survives section reloads in the editor.
    class LpSignupForm extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.busy = false;
        this.addEventListener('submit', this.onSubmit.bind(this));
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('input', this.onInput.bind(this));

        // The button ships disabled; enable it once the markup inside this element exists.
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.ready.bind(this), { once: true });
        } else {
          this.ready();
        }
      }

      ready() {
        var submit = this.ref('submit');
        if (submit && this.getAttribute('data-state') !== 'submitting') submit.disabled = false;
      }

      ref(name) {
        return this.querySelector('[data-ref="' + name + '"]');
      }

      // Shows exactly one state: idle, invalid, submitting, error or success.
      setState(state) {
        var input = this.ref('input');
        var submit = this.ref('submit');
        var idle = this.ref('idle');
        var success = this.ref('success');
        var invalid = this.ref('invalid');
        var error = this.ref('error');
        if (!input || !idle || !success) return;

        this.setAttribute('data-state', state);

        var done = state === 'success';
        idle.hidden = done;
        success.hidden = !done;
        if (invalid) invalid.hidden = state !== 'invalid';
        if (error) error.hidden = state !== 'error';

        if (state === 'invalid') {
          input.setAttribute('aria-invalid', 'true');
        } else {
          input.removeAttribute('aria-invalid');
        }

        var describedBy = [];
        if (state === 'invalid') describedBy.push(input.getAttribute('data-invalid-id'));
        if (state === 'error') describedBy.push(input.getAttribute('data-error-id'));
        var privacyId = input.getAttribute('data-privacy-id');
        if (privacyId && document.getElementById(privacyId)) describedBy.push(privacyId);
        if (describedBy.length) {
          input.setAttribute('aria-describedby', describedBy.join(' '));
        } else {
          input.removeAttribute('aria-describedby');
        }

        if (submit) {
          submit.disabled = state === 'submitting';
          if (state === 'submitting') {
            submit.setAttribute('aria-busy', 'true');
          } else {
            submit.removeAttribute('aria-busy');
          }
        }
      }

      onInput() {
        var state = this.getAttribute('data-state');
        // A stale message must not outlive the edit that fixes it.
        if (state === 'invalid' || state === 'error') this.setState('idle');
      }

      onClick(event) {
        var reset = event.target.closest ? event.target.closest('[data-ref="reset"]') : null;
        if (!reset || !this.contains(reset)) return;
        var input = this.ref('input');
        if (input) input.value = '';
        this.setState('idle');
        if (input) input.focus();
      }

      onSubmit(event) {
        event.preventDefault();
        if (this.busy) return;

        var input = this.ref('input');
        if (!input) return;
        var email = input.value.trim();

        if (!EMAIL.test(email)) {
          this.setState('invalid');
          input.focus();
          return;
        }

        var listId = (this.getAttribute('data-list-id') || '').trim();
        var companyId = (this.getAttribute('data-company-id') || '').trim();
        // Belt and braces: without both IDs nothing is ever sent.
        if (!listId || !companyId) return;

        var profile = { email: email };
        var locale = visitLocale(this);
        var market = visitMarket(this, locale);
        if (locale) profile.locale = locale;
        if (market) profile.properties = { bf_market: market };

        var self = this;
        this.busy = true;
        this.setState('submitting');

        var payload = {
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: profile } },
              custom_source: this.getAttribute('data-source') || ''
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        };

        fetch(ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            revision: '2024-10-15'
          },
          body: JSON.stringify(payload)
        })
          .then(
            // Only a 202 counts as signed up. Any other status, or no answer at all, is an error.
            function (response) {
              return response.status === 202;
            },
            function () {
              return false;
            }
          )
          .then(function (signedUp) {
            self.busy = false;
            if (!signedUp) {
              self.setState('error');
              return;
            }
            self.setState('success');
            var success = self.ref('success');
            if (success) success.focus();
            self.dispatchEvent(new CustomEvent('lp:signup:success', { bubbles: true }));
            trackLead(self.getAttribute('data-lead-source') || '', email);
          });
      }
    }

    customElements.define('lp-signup-form', LpSignupForm);
  })();
  } catch(e) { console.error(e); }
})();

})();
